import { ethers } from 'ethers';


const CONTRACT_ADDRESS = '0x383ffcd1dd5B49286bc1e02550605647ddB4b131';
const RPC_URL = 'https://testnet.skalenodes.com/v1/aware-fake-trim-testnet';

const REFERRAL_VALIDATION_ABI = [
  {
    "inputs": [
      {
        "internalType": "string",
        "name": "referralCode",
        "type": "string"
      }
    ],
    "name": "validateReferralCode",
    "outputs": [
      {
        "internalType": "bool",
        "name": "isValid",
        "type": "bool"
      },
      {
        "internalType": "uint256",
        "name": "ownerPassportId",
        "type": "uint256"
      }
    ],
    "stateMutability": "view",
    "type": "function"
  }
];

export const validateReferralCode = async (referralCode) => {
  // This function should only be called when there IS a referral code

  const trimmedCode = referralCode.trim();
  
  try {
    // Create a provider instance
    const provider = new ethers.providers.JsonRpcProvider(RPC_URL);
    
    // Create contract instance
    const contract = new ethers.Contract(CONTRACT_ADDRESS, REFERRAL_VALIDATION_ABI, provider);
    
    // Call the validateReferralCode function
    const [isValid, ownerPassportId] = await contract.validateReferralCode(trimmedCode);
    
    return {
      isValid,
      ownerPassportId: isValid ? ownerPassportId.toNumber() : null
    };
    
  } catch (error) {
    console.error('Error validating referral code:', error);
    // On error, throw to let calling code handle it
    throw new Error('Failed to validate referral code. Please try again.');
  }
};

export default validateReferralCode;